import type {TicketChannel} from '../types/ticket';
import {CHANNEL_LABELS} from './channels';
import {isCustomerPortalAvailable} from '../../../../shared/util/customerPortalAvailability';

/**
 * The channels an agent may actively choose when editing a ticket. The Client
 * Workspace channel is only offered where the firm actually has the workspace
 * enabled — but the label stays defined for every account (see `CHANNEL_LABELS`)
 * so a portal-origin ticket never falls back to its raw enum value.
 *
 * This is a function rather than a constant so it reads portal availability at
 * render time, after login state is in place.
 *
 * It lives here rather than beside `CHANNEL_LABELS` because portal availability
 * reaches `FeatureUtil`, and through it the whole `util.js` graph — modals,
 * canvas scheduling, Relay mutations. Keeping that out of `channels.ts` is what
 * lets the label map stay importable by anything that just needs to name a
 * channel (a grouping util, a header) without pulling the application in behind it.
 */
export function selectableChannels(): TicketChannel[] {
	const all = Object.keys(CHANNEL_LABELS) as TicketChannel[];
	return isCustomerPortalAvailable() ? all : all.filter(c => c !== 'customer_portal');
}
